// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FHdz","badges":"styles_badges__3jQjs"};